import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { PractiseHomePageActions } from './practise.actions';
import { selectPractiseHomeVM } from './practise-vm.selectors';
import {
  PractiseHomeCard,
  PractiseHomeVM,
} from '@lyceo/lyceo-pupil-app/practise/util-models';

@Injectable({
  providedIn: 'root',
})
export class PractiseHomeFacade {
  private readonly store: Store = inject(Store);

  public readonly practiseHomeVM: Signal<PractiseHomeVM> =
    this.store.selectSignal(selectPractiseHomeVM);

  public emptyCardClicked(): void {
    this.store.dispatch(PractiseHomePageActions.emptyCardClicked());
  }

  public cardClicked(card: PractiseHomeCard): void {
    this.store.dispatch(PractiseHomePageActions.cardClicked({ card }));
  }
}
